var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'domain-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      domainName: '',
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    domains () {
      return this.$store.getters.domainList
    },
    nextPage () {
      return this.$store.getters.domainListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.domainListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {'domain_name': this.domainName}
      this.$store.dispatch('DOMAIN_LIST_SEARCH', {url: url, data:data, callback: callback})
    },
    goDomainNew: function () {
      this.$router.push({ path: '/domains/new', query: { type: this.$router.currentRoute.query.type}})
    },
    goDomainEdit: function(domainId) {
      this.$router.push({ path: '/domains/' + domainId + '/edit'})
    },
    domainDelete: function(domainId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('DOMAIN_DELETE',  {id: domainId, callback: this.onSaved})
      }
    },
    half: function () {
      this.domainName = utils.emHalf(this.domainName)
    },
    onSaved: function (result) {
      this.$router.push('/domains')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/domain-list.js